// Client-side image compression using Canvas API.
// Resizes to fit within maxDimension (longest side) and re-encodes as JPEG.
// Modern phone photos (5-15 MB) → ~300-600 KB JPEG.
export async function compressImage(file, {
  maxDimension = 1440,
  quality = 0.82,
  maxBytes = 2_400_000,   // hard ceiling before upload
} = {}) {
  if (!file) throw new Error("Žádný soubor.");
  if (!file.type?.startsWith("image/")) throw new Error("Soubor není obrázek.");

  const dataUrl = await readAsDataURL(file);
  const img = await loadImage(dataUrl);

  // Scale down while keeping aspect ratio
  let { width, height } = img;
  const longest = Math.max(width, height);
  if (longest > maxDimension) {
    const scale = maxDimension / longest;
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  // White background for JPEG (removes alpha)
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);

  // Progressive quality reduction if still too big
  let q = quality;
  let output = canvas.toDataURL("image/jpeg", q);
  while (output.length > maxBytes && q > 0.4) {
    q -= 0.1;
    output = canvas.toDataURL("image/jpeg", q);
  }
  return output; // base64 data URI ready to POST
}

function readAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(new Error("Nepodařilo se přečíst soubor."));
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Nepodařilo se načíst obrázek."));
    img.src = src;
  });
}
